import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { NavMenuItems } from "../Constants/Constants";
import { LoginPage } from "./UserLogin/LoginPage";
import { PrivateRoute } from "./Common/PrivateRoute";
import { setBaseURL } from "../Store/apiStore";
import Service from "./Service/Service";
import ServiceProvider from "./ServiceProvider/ServiceProvider";
import ServiceOffering from "./ServiceOffering/ServiceOffering";
import DeviceModel from "./DeviceModel/DeviceModel";
import ServiceTier from "./ServiceTier/ServiceTier";
import {
  ServiceConfig,
  ServiceProviderConfig,
  GroupConfig,
  DeviceConfig,
  DeviceModelConfig,
} from "./Configuration";
import AssetManagement from "./AssetManagement/AssetManagement";
import DeviceManagement from "./DeviceSkuManagement/DeviceManagement";
import HelpPage from "./HelpPage";
import Orders from "./Order/Orders";

const Routes = () => {
  const dispatch = useDispatch();
  useMemo(() => {
    const { protocol, hostname } = window.location;
    const apiUrl = protocol + "//" + hostname;
    dispatch(setBaseURL(apiUrl));
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute exact path="/" component={ServiceProvider} />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.service.key}
          component={Service}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.orderManagement.key}
          component={Orders}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.deviceManagement.key}
          component={DeviceManagement}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.serviceProvider.key}
          component={ServiceProvider}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.codeManagement.key}
          component={AssetManagement}
        />
        <PrivateRoute
          exact
          component={HelpPage}
          path={"/" + NavMenuItems.help.key}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.serviceOffering.key}
          component={ServiceOffering}
        />
        <PrivateRoute exact path={"/test"} component={Orders} />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.serviceTier.key}
          component={ServiceTier}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.deviceModel.key}
          component={DeviceModel}
        />

        <PrivateRoute
          exact
          path={"/" + NavMenuItems.configuration.deviceModel.key}
          component={DeviceModelConfig}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.configuration.service.key}
          component={ServiceConfig}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.configuration.serviceProvider.key}
          component={ServiceProviderConfig}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.configuration.device.key}
          component={DeviceConfig}
        />
        <PrivateRoute
          exact
          path={"/" + NavMenuItems.configuration.group.key}
          component={GroupConfig}
        />

        <Route path="/login" component={LoginPage} />

        {/* TODO: redirect to page does not exist */}
        <Redirect to="/login" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
